import React, { Component } from 'react';
import { Row, Container, Col, Form, Button, Modal, Spinner, Table } from "react-bootstrap";
import Crypt from '../lib/Crypt';
import swal from 'sweetalert';
import C from '../lib/Config';

export default class ChemoMedicinePopup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            chemoMedicineName: '',
            chemoMedicine: '',
            dosageMethod: '',
            chemoMedicineArr: [],
            chemoMedicineId : 0
        }; 
        this.handleChange = this.handleChange.bind(this);
    }
    componentDidMount() {
        this.getAllMedicines();  
    }
    handleChange(event){
        if(event.target.name === 'chemoMedicine'){
            this.setState({chemoMedicine: event.target.value});
            this.setState({chemoMedicineName: event.target.options[event.target.selectedIndex].text});
        }
        if(event.target.name === 'dosageMethod'){
            this.setState({dosageMethod: event.target.value});
        } 
    }
    // validateChemo(){
    //     let formIsValid = true;
    //     let errors = {};
    //     if (this.state.chemoMedicine === "" || this.state.chemoMedicine === null) {
    //         errors["chemoMedicine"] = "Please enter first name";
    //         formIsValid = false;
    //     }
    //     if (this.state.dosageMethod === "" || this.state.dosageMethod === null) {
    //         errors["dosageMethod"] = "Please select schedule for doctor visit";
    //         formIsValid = false;
    //     } 
    //     this.setState({protocol: errors });
    //     return formIsValid;
    // }
    getAllMedicines() {
        return fetch(C.getUrl() + '/medicineMst/getAllMedicines')
            .then(res => res.json())
            .then(res => {
                if (!Array.isArray(res)) return;
                console.log("medicineArr : " + JSON.stringify(res));
                var arr = [];
                res.forEach(function (d) {
                    arr.push({ id: d.medicineId, name: d.medicineName });
                });
                this.setState({ chemoMedicineArr: arr });
            })
            .catch(err => {
                console.error("Error fetching medicines: " + err);
            });
    }
    saveChemoMedicine(){
        let data = {
            medicineId: this.state.chemoMedicine, 
            chemoMedicineName: this.state.chemoMedicineName,
            chemoInstructions: this.state.dosageMethod,
            chemoMedicineId : this.state.chemoMedicineId
        }
        this.props.saveChemoMedicine(data);
       
    }
    render() {
        const { showChemoMedicinePopup, closeModal} = this.props;
        const closePreviewModal = () => {
            closeModal();
        }
        const { chemoMedicineArr  } = this.state;
        return (
            <div>
                <Modal id="report" show={showChemoMedicinePopup} centered animation={true} scrollable={true} size="md">
                    <Modal.Header closeButton onClick={() => closePreviewModal()}>
                        <Modal.Title>
                            <h3 className="fs-18 header_title mb-0 text-black">Chemo Medicine</h3></Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Container fluid>
                            <Row>
                                <Col lg="12">
                                    <Form.Group>
                                        <Form.Label>Medicine</Form.Label>
                                        <Form.Control as="select" id="" name='chemoMedicine' value={this.state.chemoMedicine} onChange={this.handleChange}>
                                            <option value="DEFAULT">- Select Medicine -</option>
                                            {
                                                chemoMedicineArr.map((item) => (
                                                    <option key={item.id} value={item.id}>{item.name}</option>
                                                ))
                                            }
                                        </Form.Control>
                                    </Form.Group>
                                    {/* <div className="invalid-feedback">{this.state.protocol["chemoMedicine"]}</div> */}
                                </Col>
                                <Col lg='12'>
                                    <Form.Group>
                                        <Form.Label>Dosage Method</Form.Label>
                                        <Form.Control type='text' placeholder='' name='dosageMethod' onChange={this.handleChange} />
                                        {/* <div className="invalid-feedback">{this.state.protocol["dosageMethod"]}</div> */}
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Container>
                    </Modal.Body>
                    <Modal.Footer className='text-center'>
                        <Button className="btn btn-secondary" onClick={this.saveChemoMedicine.bind(this)}>
                            {this.state.saveLoader && (
                                <Spinner className='mr-2' animation='border' size='1.5rem' />
                            )}
                            Add 
                        </Button>
                        <Button variant="outline-danger" onClick={() => closePreviewModal()}>Cancel</Button>
                    </Modal.Footer>
                </Modal>
            </div>
        )
    }
}